export const entriesSelector = <T extends Record<string, any>>(
  path: string
) => {
  return (state: Record<string, any> = {}): [keyof T, T[string]][] => {
    return Object.entries(state[path] || {});
  };
};
